function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.52539 7.68551L16.0411 0.615507C16.5218 0.0938626 17.3013 0.0938626 17.782 0.615507C18.2628 1.13715 18.2628 1.9829 17.782 2.50455L11.2663 9.57455L17.782 16.6446C18.2628 17.1662 18.2628 18.012 17.782 18.5336C17.3013 19.0552 16.5218 19.0552 16.0411 18.5336L9.52539 11.4636L3.0097 18.5336C2.52895 19.0552 1.74951 19.0552 1.26876 18.5336C0.788017 18.012 0.788017 17.1662 1.26876 16.6446L7.78446 9.57455L1.26876 2.50455C0.788017 1.9829 0.788017 1.13715 1.26876 0.615507C1.74951 0.0938626 2.52895 0.0938626 3.0097 0.615507L9.52539 7.68551Z",
  fill: "#0F4C81"
});

const SvgModalXIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 19 19",
  fill: "none",
  ref: svgRef
}, props), _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgModalXIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/modal-x-icon.9c3aafc4.svg";
export { ForwardRef as ReactComponent };